// Add cloud device
export function deleteCloudDevice(addSuccess, addFailed, username, password, device_id) {
    window.cordova.exec(addSuccess, addFailed, "UniviewCameraPlugin", "deleteCloudDevice", [username, password, device_id]);
};